/**
 * Created by henian.xu on 2018/7/18.
 *
 */
import { Sp } from './Sp';

class DeviceCat extends Sp {
    constructor() {
        super();
        this.baseUrl += '/deviceCat';
    }

    data({ pId, name, deviceCatSn, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            pId,
            name,
            deviceCatSn,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, parentId, name, deviceCatSn, orderNum, isAvailable } = {}) {
        return super.post('/save', {
            id,
            parentId,
            name,
            deviceCatSn,
            orderNum,
            isAvailable,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    exists({ id, pId, name } = {}) {
        return super.get('/exists', {
            id,
            pId,
            name,
        });
    }

    select({ pId, name } = {}, config) {
        return super.get(
            '/select',
            {
                pId,
                name,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }

    loadSelectNode({ id } = {}, config) {
        return super.get(
            '/loadSelectNode',
            {
                id,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }
}

export default new DeviceCat();
export { DeviceCat };
